// extracted by mini-css-extract-plugin
export default {"iconMarker":"styles_iconMarker__rmf7F","iconEvent":"styles_iconEvent__fou0T","iconText":"styles_iconText__qn78V"};